const getStoragePath = (relativePath: string) => {
  return `https://ik.imagekit.io/jles49dvg/cloud/${relativePath
    .replace('gallery/', '')
    .replace('damages/', '')}`;
};

export default getStoragePath;
